enum RoleEnum {
    Public = 1,
    Resident = 10,
    Stakeholder = 15,
    BoardMember = 30
}

export default RoleEnum;
